/**
 * 该文件用于处理 oss 上传相关逻辑
 */

import axios from "axios";
import urls from "./urls.js";
import createUuid from "./createUuid.js";
import getExtname from "./getExtname.js";

let oss = null;

/**
 * 获取上传相关参数
 * @param {string} file - 待上传的文件地址
 */
function getFormData(file) {

    return get().then(oss => {
        return uploadWithOSS(oss, file)
    })

    function uploadWithOSS(oss, file) {
        const {
            accessid,
            dir,
            host,
            policy,
            signature
        } = oss

        let extname = getExtname(file.name);

        const uuid = createUuid();
        const filename = uuid + 'h5' + extname;
        const filekey = dir + filename;
        const uploadedFilename = `${urls.thumb}/${filekey}`;

        const formData_obj = {
            name: filename,
            key: filekey,
            policy: policy,
            OSSAccessKeyId: accessid,
            success_action_status: 200,
            signature: signature,
            file,
        }

        const formData = createFormData(formData_obj);

        return {
            formData,
            host,
            uploadedFilename
        }
    }
}

/** 获取 OSS 参数 */
function get() {
    if (isValid()) {
        return Promise.resolve(oss);
    }

    let url = urls.oss;
    return request(url).then(res => {
        return res.data;
    });
}

// 简单的封装 ajax 请求
function request(url) {
    return axios.get(url);
}

/** OSS 参数是否有效 */
function isValid() {
    if (oss === null || oss.expire <= 0) return false;

    const now = Date.now() / 1000;
    return (now + 5) < oss.expire;
}

/**
 * 将 object 转换为 FormData 类型
 * @param {object} obj
 */
function createFormData(obj) {
    let formData = new FormData();
    const keys = Object.keys(obj);
    keys.forEach(key => {
        formData.append(key, obj[key]);
    });

    return formData;
}

export default {
    getFormData
}